import { IMultiLinesItem } from './components/multiLinesControl/MultiLinesControl'

export const SPLIT_CHARACTER = '<br>'

export const TRANSLATION_NAMESPACE = 'jbp-partner-basic-info--retailer-summary--'

export const DEFAUT_SUMMARY_ITEMS: IMultiLinesItem[] = [
  // Founded (e.g. Founded in 1990 in US)
  { value: '', placeholder: `${TRANSLATION_NAMESPACE}founded` },
  // Market position (e.g. CPS: #1 with 45-50% share)
  { value: '', placeholder: `${TRANSLATION_NAMESPACE}market` },

  // These two fields are moved to RetailerFinance section
  // Latest HP Revenue: FY[PrevFYer] $XXXM
  // { value: '', placeholder: `${TRANSLATION_NAMESPACE}revenue` },
  // Current Joint Business Plan: FY[CurFYear] $XXXM
  // { value: '', placeholder: `${TRANSLATION_NAMESPACE}plan` },

  // Joint Strategical ambition (e.g. CPS: Grow Premium segment)
  { value: '', placeholder: `${TRANSLATION_NAMESPACE}ambition`, isRequired: true },
  // Additional executive info
  { value: '', placeholder: `${TRANSLATION_NAMESPACE}additional` },
]

// Additional executive info
export const DEFAUT_ADDITIONAL_ITEM: IMultiLinesItem = {
  value: '',
  placeholder: `${TRANSLATION_NAMESPACE}additional`,
}
